var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.46 6.57249C20.349 6.13825 20.1778 5.7217 19.9512 5.33499C19.7336 4.93271 19.4554 4.56633 19.1262 4.24874C18.6491 3.77318 18.084 3.39491 17.4625 3.13499C16.2115 2.62155 14.8085 2.62155 13.5575 3.13499C12.97 3.38365 12.4303 3.7326 11.9625 4.16624L11.8937 4.24874L11 5.14249L10.1062 4.24874L10.0375 4.16624C9.56965 3.7326 9.02994 3.38365 8.44249 3.13499C7.19145 2.62155 5.78853 2.62155 4.53749 3.13499C3.91597 3.39491 3.3509 3.77318 2.87374 4.24874C2.22111 4.88376 1.75913 5.68867 1.53999 6.57249C1.42341 7.02132 1.36791 7.48383 1.37499 7.94749C1.37499 8.38337 1.42999 8.81787 1.53999 9.23999C1.65526 9.6663 1.82146 10.0772 2.03499 10.4638C2.2656 10.8611 2.54761 11.2264 2.87374 11.55L11 19.6763L19.1262 11.55C19.4521 11.2296 19.7312 10.8625 19.9512 10.4638C20.3978 9.70076 20.6306 8.83154 20.625 7.94749C20.6321 7.48382 20.5766 7.02131 20.46 6.57249Z",
    fill: "#574AE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLike);
export default __webpack_public_path__ + "static/media/heartLike.20f0be4a7f4a8db7d3afef872d0e46b5.svg";
export { ForwardRef as ReactComponent };